document.querySelectorAll('.menu-list__link').forEach(link => {
  link.addEventListener('mouseenter', function(e) {
    const rect = this.getBoundingClientRect();
    const mouseX = e.clientX - rect.left;
    if (mouseX < rect.width / 2) {
      this.classList.remove('from-right');
      this.classList.add('from-left');
    } else {
      this.classList.remove('from-left');
      this.classList.add('from-right');
    }
  });
});
